import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getProduct, categoryTitle, relatedProducts } from '../utils/products';
import { productJsonLd, productMetaDescription } from '../utils/seo';
import { useSeo } from '../hooks/useSeo';
import { ProductGallery } from '../components/product/ProductGallery';
import { BuyBox } from '../components/product/BuyBox';
import { WhyGood } from '../components/product/WhyGood';
import { ProductDetails } from '../components/product/ProductDetails';
import { ProductSection } from '../components/shop/ProductSection';
import { NotFound } from './NotFound';
import type { Product as ProductType } from '../types/product';
export function Product() {
  const {
    slug = ''
  } = useParams();
  const product = getProduct(slug);
  if (!product) return <NotFound data-id="element-527" data-mp="2uwi5cgmwsrl5" />;
  return <ProductView key={product.slug} product={product} data-id="element-528" data-mp="2ux087w42u421" />;
}
function ProductView({
  product
}: {
  product: ProductType;
}) {
  useSeo({
    title: `${product.name} – ${product.subtitle} | AMIRA Beauty`,
    description: productMetaDescription(product),
    path: `/product/${product.slug}`,
    image: product.image,
    type: 'product',
    jsonLd: productJsonLd(product)
  });
  return <div className="pb-24 lg:pb-0" data-id="element-529" data-mp="dh44ffmxxdqv">
      <div className="mx-auto max-w-7xl px-5 pt-8 lg:px-8 lg:pt-10" data-id="element-530" data-mp="dg2q92amob4x">
        <nav aria-label="Kruimelpad" className="text-sm text-muted" data-id="element-531" data-mp="8iu831phc73o">
          <Link to="/" className="hover:text-ink" data-id="element-532" data-mp="8ggbgof5imu0">Home</Link>
          <span className="mx-2" data-id="element-533" data-mp="4hh3sw21cbyv">/</span>
          <Link to={`/collectie/${product.category}`} className="hover:text-ink" data-id="element-534" data-mp="3vn0atlt3jn21">{categoryTitle(product.category)}</Link>
          <span className="mx-2" data-id="element-535" data-mp="3qndw17xmdyr4">/</span>
          <span className="text-ink" data-id="element-536" data-mp="3qofjkbvtodpq">{product.name}</span>
        </nav>
        <div className="mt-6 grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-537" data-mp="3lpm8eq40cysq">
          <div className="lg:col-span-7" data-id="element-538" data-mp="1owkg2jjpzfil">
            <div className="lg:sticky lg:top-24" data-id="element-539" data-mp="1ov9ace6prxou">
              <ProductGallery product={product} data-id="element-540" data-mp="1jxg3dixl6zni" />
            </div>
          </div>
          <div className="lg:col-span-5" data-id="element-541" data-mp="1jvd2u4yt5o4j">
            <BuyBox product={product} data-id="element-542" data-mp="3edeig4sfc38y" />
          </div>
        </div>
      </div>
      <div className="mt-16 lg:mt-24" data-id="element-543" data-mp="3j44nti0uo63n">
        <WhyGood product={product} data-id="element-544" data-mp="3j56cipasgr3u" />
      </div>
      <ProductDetails product={product} data-id="element-545" data-mp="34fia1kqvfmej" />
      <div className="border-t border-line" data-id="element-546" data-mp="34gjjxlw5i2uo">
        <ProductSection title="Maak het ritueel compleet" products={relatedProducts(product)} data-id="element-547" data-mp="34dnmrzs4ni7a" />
      </div>
    </div>;
}